<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="!$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">棚卸し結果編集</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<v-form ref="form" v-model="valid">
					<template v-if="inventory_type == 'product_order_individual_info'">
						<v-text-field
							v-model="carry_over.quantity"
							label="個数"
							class="mt-4"
							outlined
							dense
							type="number"
						/>
					</template>
					<template v-if="inventory_type == 'wip_order_individual_info'">
						<v-text-field
							v-model="carry_over.quantity"
							label="個数"
							class="mt-4"
							outlined
							dense
							type="number"
						/>
					</template>
					<template v-if="inventory_type == 'component'">
						<template v-if="carry_over.target_type == 'Component'">
							<p class="text-body-2">
								部品名：{{ carry_over.target.name }}<br />部品番号：{{
									carry_over.target.part_number
								}}<br />ワイルドカード：{{ carry_over.target.wildcard ? "◯" : "×" }}
							</p>
							<v-text-field
								v-model="carry_over.quantity"
								label="個数"
								class="mt-4"
								outlined
								dense
								type="number"
							/>
						</template>
						<template v-if="carry_over.target_type == 'OrderComponent'">
							<p class="text-body-2">
								部品名：{{ carry_over.target.component.name }}<br />部品番号：{{
									carry_over.target.component.part_number
								}}<br />ワイルドカード：{{ carry_over.target.component.wildcard ? "◯" : "×" }}
							</p>
							<v-text-field
								v-model="carry_over.quantity"
								label="個数"
								class="mt-4"
								outlined
								dense
								type="number"
							/>
							<template v-if="carry_over.target.component.wildcard">
								<v-text-field
									v-model="carry_over.target.ordered_product.product_number"
									label="製造番号"
									class="mt-4"
									outlined
									dense
									disabled
								/>
								<v-text-field
									v-model="carry_over.target.component.unit_price"
									label="単価"
									class="mt-4"
									outlined
									dense
									type="number"
									suffix="円"
								/>
							</template>
						</template>
					</template>
					<template v-if="inventory_type == 'rubber'">
						<v-text-field
							v-model="carry_over.quantity"
							label="個数"
							class="mt-4"
							outlined
							dense
							type="number"
						/>
					</template>
					<template v-if="inventory_type == 'material'">
						<v-text-field
							v-model="carry_over.quantity"
							label="個数"
							class="mt-4"
							outlined
							dense
							type="number"
						/>
					</template>
					<template v-if="inventory_type == 'paint'">
						<v-text-field
							v-model="carry_over.quantity"
							label="個数"
							class="mt-4"
							outlined
							dense
							type="number"
						/>
					</template>
				</v-form>
			</v-sheet>
			<v-card-actions>
				<v-row no-gutters class="pb-2">
					<v-col sm="4" cols="0" />
					<v-col sm="4" cols="12">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="submitForm" :disabled="!valid">
								<v-icon class="mr-2">mdi-pencil</v-icon>
								編集する
							</v-btn>
						</v-row>
					</v-col>
					<v-col sm="4" cols="0" v-if="!$vuetify.breakpoint.xs">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="showDialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		selectedCarryOver: {
			type: null,
			required: false,
		},
		inventory_type: {
			type: String,
			required: false,
		},
		inventory: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			authority_flag: false,
			carry_over: {
				target: {
					component: {
						name: null,
						part_number: null,
						wildcard: null,
					},
				},
			},
			valid: false,
			common,
			rules,
		}
	},
	methods: {
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/inventories/carry_overs/${this.carry_over.id}`
			let unit_price
			if (this.carry_over.target && this.carry_over.target.component) {
				unit_price = this.carry_over.target.component.unit_price
			}

			let params = {
				carry_overs: {
					quantity: this.carry_over.quantity,
					target_type: this.carry_over.target_type,
					target_id: this.carry_over.target_id,
				},
				targets: {
					unit_price: unit_price,
					stock: this.carry_over.quantity,
				},
				inventory: {
					year: this.inventory.year,
					month: this.inventory.month,
				},
			}
			axios
				.put(url, params, { headers })
				.then((res) => {
					// TODO
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "更新しました",
					})
					this.$emit("update-carry-over", res.data.carry_over)
					this.showDialog = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		selectedCarryOver(newVal, oldVal) {
			this.carry_over = newVal
		},
	},
}
</script>
